{
  "addToFavorites": "加入收藏",
  "alertCondition": "提醒条件",
  "alertCreateFailed": "创建价格提醒失败。",
  "alertCreated": "价格提醒已创建。",
  "alertTargetValue": "提醒目标值",
  "allChains": "所有链",
  "allMarkets": "全部",
  "buyToken": "购买代币",
  "chain": "链",
  "change24h": "24小时涨跌幅",
  "chart": "图表",
  "coin": "币种",
  "contract": "合约地址",
  "contractCopied": "合约已复制。",
  "createAlert": "创建提醒",
  "exchange": "交易所",
  "favorite": "收藏",
  "filteredCoins": "筛选结果",
  "gainers": "涨幅榜",
  "holders": "持有人数",
  "hot": "热门",
  "invalidAlertValue": "请输入有效的正数。",
  "lastUpdated": "最后更新",
  "liquidity": "流动性",
  "live": "实时",
  "liveMarketBoard": "● 实时市场看板",
  "loading": "加载中...",
  "loadingMarkets": "行情加载中...",
  "losers": "跌幅榜",
  "marketCap": "市值",
  "marketCategories": "市场分类",
  "marketStatus": "市场状态",
  "marketsSubtitle": "已审核币种、已验证合约、实时图表、流动性与交易量。",
  "marketsTitle": "EXALT 行情",
  "noApprovedCoins": "未找到已审核币种。",
  "noContractFound": "未找到合约。",
  "percentChange": "变动百分比",
  "percentPlaceholder": "例如 5",
  "price": "价格",
  "priceAbove": "价格高于",
  "priceAlerts": "价格提醒",
  "priceBelow": "价格低于",
  "pricePlaceholder": "例如 50000",
  "refresh": "刷新",
  "removeFromFavorites": "从收藏中移除",
  "searchCoin": "搜索币种、代号或合约地址...",
  "staleMarketBoard": "⚠ 价格可能已过时",
  "status": "状态",
  "submittingAlert": "创建中...",
  "symbol": "代号",
  "telegram": "Telegram",
  "topGainer": "涨幅榜首",
  "topLoser": "跌幅榜首",
  "totalListedCoins": "已上线币种总数",
  "trending": "热门",
  "volume": "成交量",
  "volume24h": "24小时成交量",
  "website": "官网"
}